// extracted by mini-css-extract-plugin
export default {"rightNavigation":"CarouselRight_rightNavigation__YUUN8"};